import { defineStore } from "pinia";
import Services from '@/services/passportServices'
import { mapPassport } from '@/helpers/mapFuncs'

export const usePassportStore = defineStore("passport", {

state:()=>({
    passport: {},
    passports: [],
}),
getters : {
    getPassport() {
        return mapPassport(this.passport)
    },
    getPassports() {
        return this.passports.map(mapPassport)
    }
},
actions : {
    /** Start Sets */
    setPassport(passport) {
        this.passport = passport
    },
    setPassports(passports) {
        this.passports = passports
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setPassport(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setPassport(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setPassports(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.passports.push(response.data.data)
            return mapPassport(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.passports[this.passports.findIndex((x)=>x.id == id)] = response.data.data
            return mapPassport(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.passports = this.passports.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});